import React from 'react'
import { OutboundLink } from 'gatsby-plugin-gtag'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="INSTAR Forum">
        <EuiText>
          <p>Discuss this article on the <OutboundLink href="https://forum.instar.de/t/ddns-drittanbieter/26287">INSTAR Forum</OutboundLink> !</p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox